import { type RouteRecordRaw } from 'vue-router'
import './route-types'

export function createWhiteboardRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('./components/layouts/WhiteboardLayoutRoot.vue'),
      redirect: () => ({ name: 'portcalls.overview' }),
      children: [
        {
          path: 'overview',
          component: () =>
            import('./components/layouts/WhiteboardLayoutOverview.vue'),
          children: [
            {
              path: '',
              name: 'portcalls.overview',
              component: () => import('./views/WhiteboardView.vue')
            }
          ]
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
